import React, { useState, useEffect } from "react";
import { Form, Button } from "semantic-ui-react";
import { User, Report } from "../../../../../api";
import { useAuth } from "../../../../../hooks";
import "./CoursesByTeacher.scss";

const userController = new User();
const reportController = new Report();

export function CoursesByTeacher(props) {
  const { onClose } = props;
  const { accessToken } = useAuth();
  const [teachers, setTeachers] = useState([]);
  const [selectedTeacher, setSelectedTeacher] = useState(null);

  const [loadingExcel, setLoadingExcel] = useState(false);
  const [loadingPDF, setLoadingPDF] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const response = await userController.getTeachers();
        const teachersOptions = response.map((teacher) => ({
          key: teacher.id,
          value: teacher.id,
          text: `${teacher.lastname} ${teacher.secondLastname} ${teacher.firstname}`,
        }));
        setTeachers(teachersOptions);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [accessToken]);

  const handleExportExcel = async () => {
    setLoadingExcel(true);
    try {
      const response = await reportController.coursesByTeacher(
        accessToken,
        selectedTeacher,
        "excel"
      );

      // Crear un Blob (Binary Large Object) desde la respuesta
      // Un Blob es un objeto que representa datos binarios (como un archivo)
      const blob = new Blob([response], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob); // URL temporal en el navegador
      const a = document.createElement("a");
      a.href = url;
      a.download = `cursos_docente_${selectedTeacher}.xlsx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      // onClose(); // Cerrar el modal después de exportar
      
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingExcel(false);
    }
  };

  const handleExportPDF = async () => {
    setLoadingPDF(true);
    try {
      const response = await reportController.coursesByTeacher(
        accessToken,
        selectedTeacher,
        "pdf"
      );

      const url = window.URL.createObjectURL(response);
      const a = document.createElement("a");
      a.href = url;
      a.download = `cursos_docente_${selectedTeacher}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      // onClose(); // Cerrar el modal después de exportar
      
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingPDF(false);
    }
  };

  // Deshabilitar ambos botones si alguno está cargando
  const isDisabled = !selectedTeacher || loadingExcel || loadingPDF;

  return (
    <div className="courses-by-teacher-modal">
      <Form>
        <Form.Select
          className="edunova-select"
          label="Docente"
          placeholder="Selecciona un docente"
          fluid
          clearable
          options={teachers}
          value={selectedTeacher}
          onChange={(_, { value }) => setSelectedTeacher(value)}
          disabled={loadingExcel || loadingPDF}
        />
      </Form>

      <div className="courses-by-teacher-modal__actions">
        <Button
          color="green"
          icon="file excel"
          content="Exportar a Excel"
          onClick={handleExportExcel}
          loading={loadingExcel}
          disabled={isDisabled}
        />
        <Button
          color="red"
          icon="file pdf"
          content="Exportar a PDF"
          onClick={handleExportPDF}
          loading={loadingPDF}
          disabled={isDisabled}
        />
      </div>
    </div>
  );
}